/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Features_DescriptionInputs */

const en_seo_features_description = /** @type {(inputs: Seo_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book coaches, train with plans that adapt, log meals from a photo and see your progress: everything in the athlete app.`)
};

const pl_seo_features_description = /** @type {(inputs: Seo_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwuj trenerów, trenuj z planem, który się dopasowuje, zapisuj posiłki ze zdjęcia i śledź postępy: wszystko w aplikacji dla sportowca.`)
};

/**
* | output |
* | --- |
* | "Book coaches, train with plans that adapt, log meals from a photo and see your progress: everything in the athlete app." |
*
* @param {Seo_Features_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_features_description = /** @type {((inputs?: Seo_Features_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Features_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_features_description(inputs)
	return en_seo_features_description(inputs)
});